import { render, staticRenderFns } from "./news_info.vue?vue&type=template&id=44e5ebcc&scoped=true"
import script from "./news_info.vue?vue&type=script&lang=js"
export * from "./news_info.vue?vue&type=script&lang=js"
import style0 from "./news_info.vue?vue&type=style&index=0&id=44e5ebcc&prod&lang=scss&scoped=true"
import style1 from "./news_info.vue?vue&type=style&index=1&id=44e5ebcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e5ebcc",
  null
  
)

export default component.exports